(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const nav = document.getElementById('nav');
  const updateNav = () => {
    nav.classList.add('scrolled');
  };
  addEventListener('scroll', updateNav, { passive: true });
  addEventListener('resize', updateNav, { passive: true });
  updateNav();

  const MEGA = window.GARD_MEGA || {};
  const megaPanel = document.getElementById('megaPanel');
  const megaLabel = document.getElementById('megaLabel');
  const megaLinks = document.getElementById('megaLinks');
  const megaAll = document.getElementById('megaAll');
  const megaFeature = document.getElementById('megaFeature');
  const megaImage = document.getElementById('megaImage');
  const megaKicker = document.getElementById('megaKicker');
  const megaTitle = document.getElementById('megaTitle');
  const megaDesc = document.getElementById('megaDesc');
  const navMenuButton = document.getElementById('navMenuButton');
  const megaButtons = [...document.querySelectorAll('[data-mega]')];
  let currentMega = Object.keys(MEGA)[0] || 'gumus';

  const cachedLinks = new Map();
  const decodedImages = new Map();
  let renderedMega = null, previewRequest = 0;
  function preview(image, title, href, desc = '') {
    const request = ++previewRequest;
    megaFeature.href = href; megaTitle.textContent = title; megaDesc.textContent = desc;
    if (!image) { megaImage.hidden = true; megaImage.removeAttribute('src'); megaFeature.classList.remove('campaign-preview', 'menu-product-preview'); return; }
    if (megaImage.getAttribute('src') === image) { megaImage.hidden = false; megaFeature.classList.add('campaign-preview', 'menu-product-preview'); return; }
    if (!decodedImages.has(image)) {
      const asset = new Image(); asset.src = image;
      decodedImages.set(image, asset.decode().then(() => image).catch(() => null));
    }
    decodedImages.get(image).then(src => {
      if (src && request === previewRequest) { megaImage.src = src; megaImage.alt = title; megaImage.hidden = false; megaFeature.classList.add('campaign-preview', 'menu-product-preview'); }
    });
  }
  const renderMega = (key) => {
    const item = MEGA[key]; if (!item) return;
    currentMega = key;
    if (renderedMega === key) return;
    renderedMega = key;
    megaLabel.textContent = item.label;
    if (!cachedLinks.has(key)) cachedLinks.set(key, item.links.map(([label, href, image]) => {
      const link = document.createElement('a'); link.href = href; link.textContent = label;
      const show = () => preview(image, label, href, item.linkDesc || '');
      link.addEventListener('pointerenter', show); link.addEventListener('focus', show);
      return link;
    }));
    megaLinks.replaceChildren(...cachedLinks.get(key));
    megaAll.firstChild.textContent = item.all[0] + ' '; megaAll.href = item.all[1];
    megaKicker.textContent = item.kicker;
    preview(item.image, item.title, item.href, item.desc);
    megaAll.onpointerenter = megaAll.onfocus = () => preview(item.image, item.title, item.href, item.desc);
    megaButtons.forEach(btn => btn.classList.toggle('is-active', btn.dataset.mega === key));
  };
  const setMegaOpen = (open) => {
    nav.classList.toggle('is-open', open);
    document.body.classList.toggle('menu-open', open);
    megaPanel.setAttribute('aria-hidden', String(!open));
    megaPanel.inert = !open;
    navMenuButton.setAttribute('aria-expanded', String(open));
    navMenuButton.setAttribute('aria-label', open ? 'Menüyü kapat' : 'Menüyü aç');
    megaButtons.forEach(btn => btn.setAttribute('aria-expanded', String(open && btn.dataset.mega === currentMega)));
  };
  const canHover = matchMedia('(hover: hover) and (pointer: fine)');
  const isDesktop = () => innerWidth > 900;
  let closeTimer = 0;
  const cancelClose = () => { clearTimeout(closeTimer); closeTimer = 0; };
  const closeSoon = () => { cancelClose(); closeTimer = setTimeout(() => setMegaOpen(false), 180); };
  const openMega = (key) => { cancelClose(); renderMega(key); setMegaOpen(true); };
  const focusFirstLink = (tries = 12) => {
    const link = megaLinks.querySelector('a');
    if (!link) return;
    link.focus();
    if (document.activeElement !== link && tries > 0) requestAnimationFrame(() => focusFirstLink(tries - 1));
  };
  renderMega(currentMega);
  setMegaOpen(false);
  megaButtons.forEach(btn => {
    btn.setAttribute('aria-controls', 'megaPanel');
    btn.addEventListener('pointerenter', (event) => { if (isDesktop() && event.pointerType !== 'touch') openMega(btn.dataset.mega); });
    btn.addEventListener('click', (event) => {
      if (btn.tagName === 'A' && isDesktop()) {
        const shown = nav.classList.contains('is-open') && currentMega === btn.dataset.mega;
        if (canHover.matches || shown) return;
        event.preventDefault();
      }
      openMega(btn.dataset.mega);
    });
    if (btn.tagName === 'A') btn.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault();
      openMega(btn.dataset.mega);
      focusFirstLink();
    });
  });
  nav.addEventListener('pointerenter', cancelClose);
  nav.addEventListener('pointerleave', (event) => { if (isDesktop() && event.pointerType !== 'touch') closeSoon(); });
  document.querySelectorAll('.nav-page').forEach(link => link.addEventListener('pointerenter', () => { if (isDesktop()) { cancelClose(); setMegaOpen(false); } }));
  nav.addEventListener('focusout', (event) => {
    if (innerWidth > 900 && !nav.contains(event.relatedTarget)) setMegaOpen(false);
  });
  navMenuButton.addEventListener('click', () => setMegaOpen(!nav.classList.contains('is-open')));
  megaPanel.addEventListener('click', (event) => { if (event.target.closest('a')) setMegaOpen(false); });
  addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && nav.classList.contains('is-open')) {
      setMegaOpen(false);
      (innerWidth <= 900 ? navMenuButton : megaButtons.find(btn => btn.dataset.mega === currentMega))?.focus();
    }
  });
  document.addEventListener('click', event => { if (!nav.contains(event.target)) setMegaOpen(false); });
  addEventListener('resize', () => { if (innerWidth > 900 && navMenuButton.getAttribute('aria-expanded') === 'true') setMegaOpen(false); }, { passive: true });

  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  document.querySelectorAll('.reveal, .reveal-group').forEach(el => io.observe(el));

})();
